import { Component } from '@opten/compiler/metadata/component';

@Component({ className: 'js-gallery-360', observe: true })
export class Gallery360Component {
	private imageElements: HTMLImageElement[] = [];
	private currentIndex = 0;
	private isDragging = false;
	private startX = 0;	
	private hasInteracted = false;

	constructor(private element: HTMLElement) {
		this.imageElements = Array.from(this.element.querySelectorAll('.js-gallery-360__image')) as HTMLImageElement[];

		if (this.imageElements.length === 0) {
			return;
		}		
		const activeIndex = this.imageElements.findIndex(img => img.classList.contains('is-active'));
		this.currentIndex = activeIndex >= 0 ? activeIndex : 0;
		
		this.updateVisibleImage();		
		this.addEventListeners();
	}	

	addEventListeners() {		
		this.element.addEventListener('mousedown', this.onDragStart.bind(this), { capture: true });
		this.element.addEventListener('mousemove', this.onDragMove.bind(this), { capture: true });
		this.element.addEventListener('mouseup', this.onDragEnd.bind(this), { capture: true });
		this.element.addEventListener('mouseleave', this.onDragEnd.bind(this));		
		this.element.addEventListener('touchstart', this.onTouchStart.bind(this), { capture: true, passive: false });
		this.element.addEventListener('touchmove', this.onTouchMove.bind(this), { capture: true, passive: false });
		this.element.addEventListener('touchend', this.onDragEnd.bind(this), { capture: true });		
		this.element.addEventListener('dragstart', (e) => e.preventDefault());
	}

	onDragStart(e: MouseEvent) {
		e.stopPropagation();
		this.isDragging = true;
		this.startX = e.clientX;
		this.element.classList.add('is-dragging');
	}

	onTouchStart(e: TouchEvent) {
		e.stopPropagation();
		this.isDragging = true;
		this.startX = e.touches[0].clientX;
		this.element.classList.add('is-dragging');
	}

	onDragMove(e: MouseEvent) {
		if (!this.isDragging) return;
		e.stopPropagation();
		e.preventDefault();
		this.handleMove(e.clientX);
	}

	onTouchMove(e: TouchEvent) {
		if (!this.isDragging) return;
		e.stopPropagation();
		e.preventDefault();
		this.handleMove(e.touches[0].clientX);
	}

	handleMove(currentX: number) {
		const deltaX = currentX - this.startX;		

		if (Math.abs(deltaX) >= 10) {			
			const direction = deltaX > 0 ? -1 : 1;
			this.updateImage(direction);
			this.startX = currentX;
						
			if (!this.hasInteracted) {
				this.hasInteracted = true;
				this.element.classList.add('is-interacted');
			}
		}
	}

	updateImage(delta: number) {
		const totalImages = this.imageElements.length;
		this.currentIndex = (this.currentIndex + delta + totalImages) % totalImages;
		this.updateVisibleImage();
	}

	updateVisibleImage() {
		this.imageElements.forEach((img, index) => {
			if (index === this.currentIndex) {
				img.classList.add('is-active');
			} else {
				img.classList.remove('is-active');
			}
		});
	}

	onDragEnd() {
		this.isDragging = false;
		this.element.classList.remove('is-dragging');
	}
}
